import axiosInstance from 'src/services/common/axiosInstance'
import { API_ROUTES } from 'src/services/common/routes'

const getMonthlyLikeRankings = async () => {
  try {
    const res = await axiosInstance.get(API_ROUTES.MonthlyLikeRankings)
    if (res.data.success) {
      return res.data.items || []
    }
    return []
  } catch (error) {
    console.error('Error fetching monthly like rankings:', error)
    return []
  }
}

export default getMonthlyLikeRankings
